module.exports = __webpack_public_path__ + "static/media/card.9e2ebe46.png";